import type { TextStyleOptions } from 'pixi.js';

/**
 * Fixes TextStyleOptions for PIXI v8.
 * @param style
 */
export function fixTextStyleV8(style: TextStyleOptions): void {
  // Remove {...} brackets from the fontFamily.
  if (typeof style.fontFamily === 'string') {
    style.fontFamily = style.fontFamily.replace(/\{.*?\}/g, '');
  }

  // Fix fills for PIXI v8.
  const { fillGradientStops } = style as unknown as { fillGradientStops?: number[] };
  if (fillGradientStops && fillGradientStops.length === 0) {
    Object.assign(style, {
      fillGradientStops: undefined,
      fillGradientType: undefined,
    });
  }
}
